module.exports = __webpack_public_path__ + "static/media/YellowBook.205d8e80.svg";